import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendApi } from "../../api/apiService";
import { FiMail, FiPhone, FiCalendar, FiSearch } from "react-icons/fi";
import { MdWarning } from "react-icons/md";
import * as Icon from "react-feather";
import pdf_img from "../../images/pdf_image.png";
import { ShimmerCategoryItem } from "react-shimmer-effects";

function Blacklist() {
  const [dataResult, setDataResult] = useState([]);
  const [reason, setReason] = useState([]);
  const [menuClick, setMenuClick] = useState(false);
  const [imagePopUp, setimagePopUp] = useState(false);
  const [image, setimage] = useState("");
  const [searchParams, setSearchParams] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("UserRolesMenu")?.classList?.add("active");
    }, 500);
    getBlacklist();
  }, []);
  const [loader, setloader] = useState(false);

  const getBlacklist = () => {
    var req = {
      functionName: "blackListSiteListing",
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        console.log("response", response);
        setloader(true);
        setDataResult(response?.dataResult);
        setOriginalData(response?.dataResult);
        // setReason(response?.dataResult?.reason);
        const reasons = response?.dataResult?.map((item) => item.reason) || [];
        setReason(reasons);
      } else {
        toast.error("Error fetching blacklist data");
        return false;
      }
    });
  };

  const searchCandidates = () => {
    if (searchParams.trim() === "") {
        getBlacklist(); 
        setNoDataFound(false); 
        return;
    }

    const filteredResults = dataResult.filter(candidate =>
        candidate.full_name.toLowerCase().includes(searchParams.toLowerCase())
    );

    if (filteredResults.length === 0) {
        setDataResult([]); 
        setNoDataFound(true); 
        toast.warn("No candidates found."); 
    } else {
        setDataResult(filteredResults); 
        setNoDataFound(false); 
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchCandidates();
    }
  };
  const toggleMenu = () => setMenuClick(!menuClick);
  const closeMenu = () => setMenuClick(false);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Blacklist Records"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          {!loader ? (
            <div className="main-container">
              <div className="row">
                <div className="card main-card-box dashboard-boxes">
                  <div className="card-body">
                    <ShimmerCategoryItem />
                    <ShimmerCategoryItem />
                    <ShimmerCategoryItem />
                    <ShimmerCategoryItem />
                    <ShimmerCategoryItem />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="main-container">
              <div className="d-flex align-items-center search-desktop gap-2">
                <div className="w-100">
                  <div className="input-group">
                    <span className="input-group-text text-body search_group_text">
                      <FiSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control search_input"
                      placeholder="Search Candidate"
                      value={searchParams}
                      onChange={(e) => setSearchParams(e.target.value)}
                      onKeyDown={handleKeyPress}
                    />
                    <button
                      className="btn btn-search-custome"
                      onClick={(e) => {
                        e.preventDefault();
                        searchCandidates();
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
              <div className="xilliRight">
                <div className="xilliWrap">
                  {dataResult.map((data, index) => (
                    <div className="card main-card shadow-sm mb-4" key={index}>
                      <div className="card-body">
                        <div className="card-inner p-3">
                          <div className="row">
                            <div className="col-12">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="job-view-header mb-0 text-danger">
                                  <MdWarning className="me-2" size={24} />
                                  {data.full_name}
                                </h4>
                                <span className="badge bg-danger px-3 py-2">
                                  Blacklisted
                                </span>
                              </div>

                              <div className="info-grid mb-4">
                                <div className="info-item">
                                  <FiMail className="text-muted me-2" />
                                  <span>{data.email_id}</span>
                                </div>
                                <div className="info-item">
                                  <FiPhone className="text-muted me-2" />
                                  <span>{data.mobile_no}</span>
                                </div>
                              </div>

                              <div className="blacklist-details p-3 bg-light rounded mb-4">
                                <div className="d-flex justify-content-between mb-3">
                                  <div>
                                    <strong className="text-dark">
                                      Period:
                                    </strong>
                                    <div className="mt-1">
                                      <FiCalendar className="text-success me-2" />
                                      {formatDate(data.duration_start)}
                                      <span className="mx-2">to</span>
                                      <FiCalendar className="text-danger me-2" />
                                      {formatDate(data.duration_end)}
                                    </div>
                                  </div>
                                  <div>
                                    <strong className="text-dark">
                                      Blacklisted By:
                                    </strong>
                                    <div className="mt-1 text-uppercase fw-bold">
                                      {data.blacklisted_by}
                                    </div>
                                  </div>
                                </div>

                                <div className="reasons-section">
                                  {dataResult.length > 0 ? (
                                    <>
                                      <strong className="text-dark d-block mb-2">
                                        Reasons for Blacklisting:
                                      </strong>
                                      {data.reason.map(
                                        (itemmm, reasonIndex) => (
                                          <div
                                            key={reasonIndex}
                                            className="reason-item bg-white p-3 rounded mb-2"
                                          >
                                            <div className="text-danger fw-medium mb-1">
                                              •{" "}
                                              {itemmm.reason || "Not Available"}
                                            </div>
                                            {itemmm.reason_details && (
                                              <div className="text-muted ms-3">
                                                Details: {itemmm.reason_details}
                                              </div>
                                            )}
                                            {itemmm.notes && (
                                              <div className="text-muted ms-3">
                                                Notes: {itemmm.notes}
                                              </div>
                                            )}
                                            <div className="d-flex flex-row my-2 flex-wrap">
                                              {itemmm.doc_attach1 && (
                                                <span
                                                  className="d-flex flex-column my-2"
                                                  onClick={() => {
                                                    setimagePopUp(true);
                                                    setimage(
                                                      itemmm.doc_attach1
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      itemmm.doc_attach1.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? pdf_img
                                                        : itemmm.doc_attach1
                                                    }
                                                    width="200"
                                                    alt="profile-img"
                                                    className="img-fluid img-upload"
                                                  />
                                                </span>
                                              )}
                                              {itemmm.doc_attach2 && (
                                                <span
                                                  className="d-flex flex-column my-2"
                                                  onClick={() => {
                                                    setimagePopUp(true);
                                                    setimage(
                                                      itemmm.doc_attach2
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      itemmm.doc_attach2.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? pdf_img
                                                        : itemmm.doc_attach2
                                                    }
                                                    width="200"
                                                    alt="profile-img"
                                                    className="img-fluid img-upload"
                                                  />
                                                </span>
                                              )}
                                              {itemmm.doc_attach3 && (
                                                <span
                                                  className="d-flex flex-column my-2"
                                                  onClick={() => {
                                                    setimagePopUp(true);
                                                    setimage(
                                                      itemmm.doc_attach3
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      itemmm.doc_attach3.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? pdf_img
                                                        : itemmm.doc_attach3
                                                    }
                                                    width="200"
                                                    alt="profile-img"
                                                    className="img-fluid img-upload"
                                                  />
                                                </span>
                                              )}
                                              {itemmm.doc_attach4 && (
                                                <span
                                                  className="d-flex flex-column my-2"
                                                  onClick={() => {
                                                    setimagePopUp(true);
                                                    setimage(
                                                      itemmm.doc_attach4
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      itemmm.doc_attach4.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? pdf_img
                                                        : itemmm.doc_attach4
                                                    }
                                                    width="200"
                                                    alt="profile-img"
                                                    className="img-fluid img-upload"
                                                  />
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <div className="text-muted">
                                      No reasons available for blacklisting.
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="text-muted">
                                <small>
                                  Blacklisted On: {formatDate(data.created_on)}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {noDataFound && (
            <div className="no-data-message">
              <p className="text-white">No Data Found</p>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
        }

        .info-item {
          display: flex;
          align-items: center;
        }

        .reason-item {
          border-left: 3px solid #dc3545;
        }

        .blacklist-details {
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        .badge {
          font-weight: 500;
          letter-spacing: 0.5px;
        }
      `}</style>

      {imagePopUp && (
        <div className="module_popup addPeople" id="addsprint">
          <div className="module_innerpopup module_bodypop">
            <div className="module_headdiv">
              <div className="module_close">
                <Icon.X
                  color="grey"
                  onClick={() => {
                    setimagePopUp(false);
                    setimage("");
                  }}
                  size={18}
                />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              {image.endsWith(".pdf") ? (
                // Display PDF
                <iframe
                  src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                    image
                  )}`}
                  title="PDF Preview"
                  width="100%"
                  height="500px"
                  style={{ border: "1px solid #ccc" }}
                />
              ) : (
                // Display Image
                <img
                  src={image}
                  width="100%"
                  alt="profile-img"
                  className="img-fluid"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Blacklist;
